import { absolutePath } from "./absolutePath";

interface PaywallCouponsFnProps {
  params?: Record<string, unknown>;
  paywallCouponId?: string | number;
}

export interface PaywallCouponAppliedProps {
  community_id: number;
  coupon_code: string;
  paywall_price_id: number;
  skip_inactive_coupon_validation: boolean;
}

interface CalculateDiscountProps {
  params?: Partial<PaywallCouponAppliedProps>;
}

export const paywallCoupons = {
  index: ({ params = {} }: PaywallCouponsFnProps = {}) =>
    absolutePath("paywalls/coupons", params),
  show: ({ paywallCouponId, params = {} }: PaywallCouponsFnProps = {}) =>
    absolutePath(`paywalls/coupons/${paywallCouponId}`, params),
  create: ({ params = {} }: PaywallCouponsFnProps = {}) =>
    absolutePath("paywalls/coupons/", params),
  update: ({ paywallCouponId, params = {} }: PaywallCouponsFnProps = {}) =>
    absolutePath(`paywalls/coupons/${paywallCouponId}`, params),
  destroy: ({ paywallCouponId }: PaywallCouponsFnProps = {}) =>
    absolutePath(`paywalls/coupons/${paywallCouponId}`),
  calculateDiscount: ({ params = {} }: CalculateDiscountProps = {}) =>
    absolutePath("paywalls/coupons/calculate_discount", params),
};
